
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { withCookies } from 'react-cookie';
import { EXPRESS_VERB } from "../../lib/debug-constants";
import {setAppOrientation, setAppResolution} from "./actions";
import { getUnreadCount } from "../inbox/actions";

/* CSS */
import "../styles/core.scss";
import 'react-table/react-table.css'

/* Navigation */
import Navigate from "../nav";

/* Routes */
import Home from '../home/';
import Login from '../login/login';
import NewPassword from "../login/new-password";
import NewAccount from "../login/new-account";
import ForgotPassword from "../login/forgot-password";
import OnboardingLayout from "../onboarding";

import Header from "./Header";
import { Logout } from "./logout";
import Footer from "./Footer";
import { SpinnerOverlay } from "../components/spinner-overlay";

import User from "../user/";
import Superadmin from "../superadmin";
import WlfAdmin from "../wlf-admin";
import { CDContainer } from "../cd/CDContainer";

import UGMALanding from "../components/UGMAInvite/UGMALanding";
import {dispatch_logout} from "./logout-dispatch";
import {set_app_instance} from "./popup_window_factory";
import {navigatePath} from "../nav/actions";
import { loginSetUser } from "../login/login/actions";
import {ORIENTATION} from "../../lib/constants";

const Page404 = props => (
  <section className="hero is-large">
    <div className="hero-body has-text-centered">
      <h5 className="title is-5">Oops! This page does not exist.</h5>
    </div>
  </section>
);

const RedirectToLogin = ({ location }) => (
  <div>
    { console.log("RedirectToLogin") }
    <Redirect to={"/login?redirect=" + location.pathname + location.search} />
  </div>
);

const RedirectToLogin_2 = () => (
  <div>
    { console.log("RedirectToLogin_2") }
    <Redirect to={"/login"} />
  </div>
);

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show_menu: false,
    }
    set_app_instance(this);
  }

  componentDidMount() {
    this.updateDimensions();
    if (this.props.isLoggedIn) {
      this.props.getUnreadCount();
    }
    window.addEventListener("resize", this.updateDimensions);
    const orientation =
      window.matchMedia("(orientation: portrait)").matches
      ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE;
    this.props.setAppOrientation(orientation);
    window.matchMedia("(orientation: portrait)").addEventListener(
      "change", this.orientationListener);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.matchMedia("(orientation: portrait)").removeEventListener(
      "change", this.orientationListener);

  }

  updateDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    this.props.setAppResolution(width, height);
  }

  orientationListener = ev => {
    this.props.setAppOrientation(
      ev.matches ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE )
  }

  render() {
    const { isLoggedIn } = this.props;
    const is_loading = this.props.app.isLoading;
    const has_wlf = !!this.props.app.wlf;
    const fontStyle = {
      fontFamily: "Poppins",
      fontSize: "1rem",
      fontWeight: "500",
    };
    //const is_onboarding = this.props.location.pathname.startsWith('/onboarding');

    const withLoginCheck = Component => {
      return isLoggedIn ? Component : RedirectToLogin;
    }

    const withOnboardingCheck = component => {
      if (!isLoggedIn) {
        return RedirectToLogin_2;
      }
      return component;
    };

    if (EXPRESS_VERB) {
      console.log("App route", this.props.location.pathname);
    }

    return (
      <div style={fontStyle}>
        {/* When a component is wrapped in connect with Redux Store, the component is exported as an object */}
        {/* So passing in an object into component prop will throw a warning since the component prop is expecting a function */}
        {/* To circumvent this, we must render the component manually with render props */}
        <Route component={Navigate} />
    
        { is_loading && <SpinnerOverlay/> }

        { has_wlf && <Route component={Header} />}

        <Switch>
          {/* PUBLIC ROUTES */}
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/login/" component={Login} />
          <Route exact path="/new_account/" component={NewAccount} />
          <Route exact path="/new_account_mobile/" component={NewAccount} />
          <Route exact path="/new_password/" component={NewPassword} />
          <Route exact path="/forgot_password/" component={ForgotPassword} />
          <Route exact path="/offerings" component={CDContainer} />
          <Route exact path="/" component={Home} />

          {/* LOGGED IN ROUTES */}
          <Route exact path="/user" component={withOnboardingCheck(User)} />
          <Route exact path="/user/*" component={withOnboardingCheck(User)} />
          <Route exact path="/super-admin/*" component={withLoginCheck(Superadmin)} />
          <Route exact path="/wlf-admin/*" component={withLoginCheck(WlfAdmin)} />

          { /* LOGGED IN OR ONBOARDING ROUTES */ }
          <Route exact path="/onboarding_*/*" component={withOnboardingCheck(OnboardingLayout)} />

          { /* LOGGED IN UGMA INVITE ROUTES */ }
          <Route exact path="/ugma-invite" component={withLoginCheck(UGMALanding)} />
          <Route exact path="/ugma-invite/*" component={withLoginCheck(UGMALanding)} />

          {/* 404 ROUTE */}
          <Route component={Page404} />
        </Switch>
        {has_wlf && <Route component={(props) => <Footer {...props}/>} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: !!(state.user && state.user.token),
    user: state.user,
    hasOnboardingToken: !!(state.user && state.user.onboarding_token),
    wlf: state.wlf,
    app: state.app,
    onboarding: state.onboarding,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setAppResolution: (width, height) => dispatch(setAppResolution(width, height)),
    getUnreadCount: () => dispatch(getUnreadCount()),
    logout: () => { dispatch_logout(dispatch) },
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
    loginSetUser: user => { dispatch(loginSetUser(user)) },
    setAppOrientation: orientation => dispatch(setAppOrientation(orientation)),
  };
};

export default withCookies(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
);